import React, { useEffect, useState } from 'react';
import './ValidationReferencesDuplicateDetected.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faArrowLeft, faArrowRight, faClose } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { Trans, useTranslation } from 'react-i18next';
import { IRefOrder } from 'applications/automotor/views/espace-automotor-order/automotor-order.mode';
import CURRENCY from 'utils/constants/currency';
import Pagination from 'components/pagination/Pagination';
import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};
type IRowTable = {
  [key: string]: string | number | null | { totalPrice: string; index: number };
};

const ValidationReferencesDuplicateDetected: React.FC<Props> = (props) => {

  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  const user = JSON.parse(localStorage.getItem('userData')!);
  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [data, setData] = useState<Array<IRefOrder>>([]);
  const [dataPagination, setDataPagination] = useState<Array<IRefOrder>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(5);
  const [totalPages, setTotalPages] = useState<number>(0);

  useEffect(() => {
    if (props.stepModalNext === 'ValidationReferencesDuplicateDetected') {
      const duplicates = proformaFile?.duplicated_rows;

      const data = duplicates.reduce((rows: Array<IRowTable>, row, currentIndex) => {
        const qte = +(row.data[6] as number);

        const data = {
          reference: row.data[4],
          brand: 'brand1',
          file_price: row.info?.price_from_file ? `${Number(row.info?.price_from_file).toFixed(2)} ${CURRENCY[user!.currency]}` : (row.data[7] ? `${Number(row.data[7]).toFixed(2)} ${CURRENCY[user!.currency]}` : '-'),
          sell_price: row.info?.current_price ? `${Number(row.info?.current_price).toFixed(2)} ${CURRENCY[user!.currency]}` : '-',
          qte: qte,
          description: (row.info?.description ? row.info?.description : row.data[5]),
          total: {
            totalPrice: `${CURRENCY[user!.currency]}${row.info?.current_price * qte}`,
            index: currentIndex,
          },
          supplier_name: row.info?.supplier_name ? row.info?.supplier_name : '-',
          index: row.data[0],
          reference_internal: row.data[2],
          supplier_logo: row.info?.supplier_logo || '/images/car-part-placeholder-big.png'

        };

        rows.push(data);

        return rows;
      }, []);

      setData(data);
    }
  }, [props.stepModalNext]);

  useEffect(() => {
    if (data.length > 0) {
      const total = data.length;

      setTotalPages(Math.ceil(total / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      setDataPagination(data.slice(startIndex, endIndex));
    }


  }, [data, currentPage, itemsPerPage]);

  const handlePageClick = (page: number) => {
    setCurrentPage(page);

  };

  return (
    <div className="validation-custumer-order-duplicate-modal" >
      <div className="close upload_order_info_dublicate_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>
      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{t('_warning_duplicate_references_detected')}</div>
          <div className="validation-customer-modal-subtitle">
            <Trans
              i18nKey="_validation_warning_duplicate"
              components={{ bold: <br /> }}

            />
          </div>
        </div>
        <div className="validation-customer-modal-row">
          <table className="validation-customer-modal-table">
            <thead>
              <tr >
                <th className="text-align-left"> {t('_reference')} / {t('_description')}</th>
                <th className="text-align-left">{t('_brand')}</th>
                {/* <th >{t('_quantity_order')}</th> */}


              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                dataPagination.map((row, index) => (
                  <tr key={row.reference + row.index + index}>

                    <td className="text-align-left">{row.description ? `${row.reference ?? ''} / ${row.description}` : row.reference ?? ''}</td>

                    <td>
                      <div className="brand">
                        <div>
                          <img src={row.supplier_logo} onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = '/images/car-part-placeholder-big.png';
                          }} alt="provider-logo" height={16}
                          /> </div>
                        <div>{row.supplier_name || row.name}</div>

                      </div>
                    </td>
                    {/* <td>{row.qte}</td> */}

                  </tr>)))
                :
                <tr>
                  <td colSpan={2} className="no-data">{t('_no_data')}</td>
                </tr>
              }


            </tbody>
          </table>
          {totalPages > 1 && (
            <Pagination pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} hiddenParamPage iconsPrevious={faArrowLeft} iconsNext={faArrowRight} />
          )}
        </div>

        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            <DefaultButton className="validation-customer-modal-btn upload_order_info_dublicate" text={t('_send_the_order_for_processing')} onClick={() => { props.setStepModal('ValidationReferencesMultipleProviders'); }} />

            <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_dublicate_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

          </div>

        </div>

      </div>
    </div>
  );

};

ValidationReferencesDuplicateDetected.displayName = 'ValidationReferencesDuplicateDetected';

export default ValidationReferencesDuplicateDetected;